<div class="cssload-loader">
	<div class="cssload-inner cssload-one"></div>
	<div class="cssload-inner cssload-two"></div>
	<div class="cssload-inner cssload-three"></div>
  <div class="loader__label" *ngIf="label">{{ label }}</div>
</div>
